import { ArrowLeftOutlined, ArrowRightOutlined } from '@icon';
import { Calendar } from '@rehookify/datepicker';
import React from 'react';
import IconButton from '../../../../icon-button';
import CalendarHeader from '../../../components/calendar-header';
import DatePanel from '../../../components/date-panel/date-panel';
import DateTitle from '../../../components/date-title';
import { TPropsGetters } from '../../../date-time.types';
import { TPanelMode } from '../../../date-time.utils';

interface DatePickerDaysProps {
  mode?: TPanelMode;
  setPanelMode: React.Dispatch<React.SetStateAction<TPanelMode>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  weekDays: string[];
  calendars: Calendar[];
  propGetters: TPropsGetters;
}

const DatePickerDays: React.FunctionComponent<DatePickerDaysProps> = ({
  mode,
  setPanelMode,
  setOpen,
  calendars,
  weekDays,
  propGetters,
}) => {
  return (
    <div>
      <CalendarHeader
        left={
          <IconButton
            Icon={ArrowLeftOutlined}
            size="small"
            variant="ghost-tertiary"
            {...propGetters.previousMonthButton()}
          />
        }
        right={
          <IconButton
            Icon={ArrowRightOutlined}
            size="small"
            variant="ghost-tertiary"
            {...propGetters.nextMonthButton()}
          />
        }
      >
        <DateTitle
          month={calendars[0].month}
          year={calendars[0].year}
          onMonthClick={mode === 'date' ? () => setPanelMode('month') : undefined}
          onYearClick={mode === 'date' ? () => setPanelMode('year') : undefined}
        />
      </CalendarHeader>
      <DatePanel
        dayButton={propGetters.dayButton}
        days={calendars[0].days}
        weekDays={weekDays}
        weekDaysPrefix={calendars[0].month}
        config={{
          onClick: (_, date) => {
            if (date) {
              setOpen(false);
            }
          },
        }}
      />
    </div>
  );
};

export default DatePickerDays;
